import { useEffect } from "react";
import { useDispatch } from "react-redux";
import useCustomState from "../hooks/State";
import { UpdateNavigations } from "../store/actions";
import BillsFilter from "../components/BillsFilter";
import SelectTable from "../components/CustomTable/SelectTable";
import Call from "../service/API";
import moment from "jalali-moment";
import "../components/BillsFilter/main.css";
const CreateBill = () => {
  const isLoading = useCustomState(true);
  const projects = useCustomState([]);
  const counterList = useCustomState([]);
  const countersResult = useCustomState([]);
  const showOnlySelectedCounters = useCustomState(false);
  const dataTable = useCustomState([]);
  const projectSelected = useCustomState("");
  const counterSelected = useCustomState("");
  const selectedList = useCustomState([]);
  const modalStatus = useCustomState(false);
  const showOnlySelectedCountersChanged = (e) => {
    if (e.target.checked) {
      showOnlySelectedCounters.handleChange(true);
    } else {
      showOnlySelectedCounters.handleChange(false);
    }
  };
  const utils = {
    page: 1,
    count: 10000,
    projectNameFilter: null,
    projectCreateDateFilter: null,
  };

  const selectProjectChange = (event) => {
    projectSelected.handleChange(event.target.value);
    if (!!event.target.value && event.target.value.length > 0) {
      fetchCounters(event.target.value, counterList, countersResult);
    }
  };
  const filterResult = () => {
    const data = [];
    selectedList.handleChange([]);
    console.log(countersResult.value);
    countersResult.value.forEach((item) => {
      if (
        item.water_meter_tag_info.water_meter_tag_id === counterSelected.value
      ) {
        data.push({
          couName: item.water_meter_name,
          couSerial: item.water_meter_serial,
          // lstCunsTime: item.water_meter_status.last_consumption_time
          //   ? moment(item.water_meter_status.last_consumption_time)
          //       .locale("fa")
          //       .format("YYYY/MM/DD")
          //   : "__",
          owner: `${item.water_meter_user_info.user_name} ${item.water_meter_user_info.user_lastname}`,
          id: item.water_meter_serial,
        });
      }
    });
    dataTable.handleChange(data);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    const navigations = [{ name: "صدور قبض", path: "/admin/create-bills" }];
    dispatch(UpdateNavigations(navigations));
    fetchprojectsList(utils, isLoading, projects);
  }, []);
  const headers = [
    { title: "نام کنتور", key: "couName" },
    { title: "شماره سریال", key: "couSerial" },
    // { title: "ثبت آخرین مصرف در", key: "lstCunsTime" },
    { title: "مالک کنتور", key: "owner" },
  ];
  const handleSelectedList = (event) => {
    const id = event.target.id;
    let new_selected = [...selectedList.value];
    if (new_selected.indexOf(id) > -1) {
      new_selected = new_selected.filter((item) => item !== id);
    } else {
      new_selected.push(id);
    }
    selectedList.handleChange(new_selected);
  };
  if (!isLoading.value) {
    return (
      <>
        <div style={{ paddingRight: "8px", paddingLeft: "8px" }}>
          <BillsFilter
            modalStatus={modalStatus}
            selectedList={selectedList}
            showOnlySelectedCounters={showOnlySelectedCounters}
            showOnlySelectedCountersChanged={showOnlySelectedCountersChanged}
            filterResult={filterResult}
            counterSelected={counterSelected}
            selectProjectChange={selectProjectChange}
            projects={projects}
            counterList={counterList}
            projectSelected={projectSelected}
          />
          <SelectTable
            handleSelectedList={handleSelectedList}
            selectedList={selectedList}
            showOnlySelectedCounters={showOnlySelectedCounters}
            headers={headers}
            data={dataTable.value}
          />
        </div>
      </>
    );
  } else {
    return null;
  }
};

export default CreateBill;

const fetchprojectsList = (utils, isLoading, projects) => {
  const page = utils.page;
  const count = utils.count;
  const projectNameFilter = utils.projectNameFilter;
  const projectCreateDateFilter = utils.projectCreateDateFilter;
  const data = {
    page: page,
    count: count,
    water_meter_project_name: projectNameFilter,
    water_meter_project_create_date: projectCreateDateFilter,
  };
  Call("POST", "WaterMeterProjectsURL/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        const ps = response.data.data;
        projects.handleChange(ps);
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        if (data.code === 403) {
        }
      }
      isLoading.handleChange(false);
    });
};

const fetchCounters = (projectId, counterList, countersResult) => {
  const page = 1;
  const count = 1000;
  const userId = null;

  const data = {
    page: page,
    count: count,
    user_id: userId,
    project_id: projectId,
  };
  Call("POST", "watermeters/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        let counters = [];
        let counters_list = [];
        response.data.data.forEach((item) => {
          if (
            counters.indexOf(item.water_meter_tag_info.water_meter_tag_id) ===
            -1
          ) {
            counters.push(item.water_meter_tag_info.water_meter_tag_id);
            counters_list.push({
              id: item.water_meter_tag_info.water_meter_tag_id,
              name: item.water_meter_tag_info.water_meter_tag_name,
            });
          }
        });
        countersResult.handleChange(response.data.data);
        counterList.handleChange(counters_list);
      }
    })
    .catch((error) => {
      if (error.response) {
        counterList.handleChange([]);
        countersResult.handleChange([]);
      }
    });
};
